import React from 'react';
import PropTypes from 'prop-types';
import MessageFilled from '@ant-design/icons/MessageFilled';
import { useQuery } from 'react-query';

import HtmlText from '../html-text';
import { getParameterMessage } from '../../services/dataset.service';

const ParameterMessage = (props) => {
  const { parameterId } = props;

  const { data } = useQuery(
    ['parameterMessage', parameterId],
    () => getParameterMessage(parameterId),
  );

  if (!data || !data.message) {
    return null;
  }

  return (
    <div className="dataset-message-wrapper">
      <div className="dataset-message">
        <MessageFilled />
        <HtmlText string={data?.message} />
      </div>
    </div>
  );
};

ParameterMessage.propTypes = {
  parameterId: PropTypes.number,
};

ParameterMessage.defaultProps = {
  parameterId: undefined,
};

export default ParameterMessage;
